import Spinner from "../../assets/Spinner.svg";
import './HookLoader.scss';

interface Props {
    loading: boolean
}

function HookLoader({ loading }: Props) {

    if (!loading) return null;
    return (
        <div className='loader-container'>
            <div className='loader'>
                <img src={Spinner} alt='spinner' />
            </div>
        </div>
    )
}

export default HookLoader;